export default {"src":"/login-app/[GIT_HASH]/_next/static/media/label.4cfe5602.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};